export const adminCreateUser = /* GraphQL */ `
  mutation AdminCreateUser(
    $username: String!
    $email: String!
    $password: String!
    $profilePictureBase64: String
    $profilePictureContentType: String
  ) {
    adminCreateUser(
      username: $username
      email: $email
      password: $password
      profilePictureBase64: $profilePictureBase64
      profilePictureContentType: $profilePictureContentType
    ) {
      success
      message
    }
  }
`;
